import { FullContainer } from '@gorila-shared-ui/components';
import { Tab, Tabs } from 'baseui/tabs-motion';
import { useState } from 'react';
import { useStyles } from '../../../hooks/useStyles';
import OperationalDownloadsTab from '../../donwloads/OperationalDownloadsTab';

function FleetDownloadsPage() {
  const {
    overrides: { tabOverrides, tabsOverrides },
  } = useStyles();
  const [activeKey, setActiveKey] = useState(0);

  return (
    <FullContainer verticalFlex>
      <Tabs
        activeKey={activeKey}
        onChange={({ activeKey }) => {
          setActiveKey(activeKey as number);
        }}
        activateOnFocus
        overrides={tabsOverrides}
      >
        <Tab
          title="Operaciones"
          overrides={tabOverrides}
        >
          <OperationalDownloadsTab />
        </Tab>
      </Tabs>
    </FullContainer>
  );
}

export default FleetDownloadsPage;
